import EstalyManagersService from "@/api/services/estalyManagers";
import { toCamelCase } from "@/utils/utils";

// Claims handlers fit in one page: the Estaly team is a few dozen people.
const CLAIMS_HANDLERS_PER_PAGE = 100;

export default {
  namespaced: true,

  state: {
    claimsHandlers: [],
  },

  mutations: {
    setClaimsHandlers(state, claimsHandlers) {
      state.claimsHandlers = claimsHandlers;
    },
  },

  actions: {
    async fetchClaimsHandlers({ commit }) {
      const response = await EstalyManagersService.fetchIndex({
        role: "claims_handler",
        perPage: CLAIMS_HANDLERS_PER_PAGE,
      });

      if (!response?.success) return response;

      commit("setClaimsHandlers", toCamelCase(response.data).estalyManagers);

      return response;
    },
  },
};
